import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {DisplayAdType} from './DisplayAdType.enum';

export function DisplayAdFallback({
  type,
  onClickAppLink,
  isWebView,
}: {
  type: DisplayAdType;
  onClickAppLink: () => void;
  isWebView?: boolean;
}) {
  return (
    <StaticImage
      onClick={onClickAppLink}
      imageType={
        type === 'normal'
          ? isWebView
            ? StaticImageType.DabannerCashfriendsStatic
            : StaticImageType.InstallBannerDaMw
          : isWebView
            ? StaticImageType.ExpandCashfriendsStatic
            : StaticImageType.InstallBannerViewerEndMw
      }
      className="h-full object-contain"
    />
  );
}
